module.exports = __webpack_public_path__ + "static/media/StreetLamp.68a5fc00.svg";